export default "__VITE_ASSET__CXujBaZB__"